/*
 * Words used on many screens: buttons, field names, form rules.
 * Owned by wave 1 and FROZEN during wave 2 - read it, do not edit it. A common word
 * that is missing here goes in your own area module (same key and text if another
 * area already added it; I18nMessagesTest checks that duplicates agree).
 *
 * Keys are the Android ones from the translation memory where it had the word.
 */
export default {
  // Buttons
  labelSave: { en: 'Save', fr: 'Enregistrer', es: 'Guardar' },
  cancelButton: { en: 'Cancel', fr: 'Annuler', es: 'Cancelar' },
  app_ai_close: { en: 'Close', fr: 'Fermer', es: 'Cerrar' },
  labelBack: { en: 'Back', fr: 'Retour', es: 'Volver' },
  labelYes: { en: 'Yes', fr: 'Oui', es: 'Sí' },
  labelNo: { en: 'No', fr: 'Non', es: 'No' },
  labelOk: { en: 'OK', fr: 'OK', es: 'Aceptar' },
  dailylog_delete: { en: 'Delete', fr: 'Supprimer', es: 'Eliminar' },
  dailylog_edit: { en: 'Edit', fr: 'Modifier', es: 'Editar' },
  employee_add_button: { en: 'Add', fr: 'Ajouter', es: 'Añadir' },
  common_add_another: { en: 'Add Another', fr: 'Ajouter un autre', es: 'Añadir otro' },
  labelRemove: { en: 'Remove', fr: 'Retirer', es: 'Quitar' },
  common_restore: { en: 'Restore', fr: 'Restaurer', es: 'Restaurar' },
  action_refresh: { en: 'Refresh', fr: 'Actualiser', es: 'Actualizar' },
  ui_filter_reset: { en: 'Reset', fr: 'Réinitialiser', es: 'Restablecer' },
  labelUpdate: { en: 'Update', fr: 'Mettre à jour', es: 'Actualizar' },
  labelDetails: { en: 'Details', fr: 'Détails', es: 'Detalles' },
  actions_title: { en: 'Actions', fr: 'Actions', es: 'Acciones' },
  ui_search: { en: 'Search', fr: 'Rechercher', es: 'Buscar' },
  labelDone: { en: 'Done', fr: 'Terminé', es: 'Listo' },
  common_next: { en: 'Next', fr: 'Suivant', es: 'Siguiente' },
  common_previous: { en: 'Previous', fr: 'Précédent', es: 'Anterior' },
  common_export: { en: 'Export', fr: 'Exporter', es: 'Exportar' },
  common_import: { en: 'Import', fr: 'Importer', es: 'Importar' },
  actions_download: { en: 'Download', fr: 'Télécharger', es: 'Descargar' },
  common_download_csv: { en: 'Download CSV', fr: 'Télécharger le CSV', es: 'Descargar CSV' },
  common_preview: { en: 'Preview', fr: 'Aperçu', es: 'Vista previa' },
  common_move: { en: 'Move', fr: 'Déplacer', es: 'Mover' },
  common_open_new_tab: { en: 'Open in New Tab', fr: 'Ouvrir dans un nouvel onglet', es: 'Abrir en una pestaña nueva' },

  // Progress
  common_saving: { en: 'Saving...', fr: 'Enregistrement...', es: 'Guardando...' },
  common_loading: { en: 'Loading...', fr: 'Chargement...', es: 'Cargando...' },
  global_loading_please_wait: { en: 'Loading please wait...', fr: 'Chargement, veuillez patienter...', es: 'Cargando, espere...' },

  // Field names
  labelName: { en: 'Name', fr: 'Nom', es: 'Nombre' },
  labelEmail: { en: 'Email', fr: 'Courriel', es: 'Correo electrónico' },
  app_help_phone: { en: 'Phone', fr: 'Téléphone', es: 'Teléfono' },
  labelAddress: { en: 'Address', fr: 'Adresse', es: 'Dirección' },
  user_street: { en: 'Street', fr: 'Rue', es: 'Calle' },
  user_city: { en: 'City', fr: 'Ville', es: 'Ciudad' },
  user_postal_code: { en: 'Postal Code', fr: 'Code postal', es: 'Código postal' },
  user_country: { en: 'Country', fr: 'Pays', es: 'País' },
  vehicle_province_label: { en: 'Jurisdiction', fr: 'Juridiction', es: 'Jurisdicción' },
  labelStatus: { en: 'Status', fr: 'Statut', es: 'Estado' },
  common_state: { en: 'State', fr: 'État', es: 'Estado' },
  common_active: { en: 'Active', fr: 'Actif', es: 'Activo' },
  common_inactive: { en: 'Inactive', fr: 'Inactif', es: 'Inactivo' },
  common_all: { en: 'All', fr: 'Tous', es: 'Todos' },
  common_unknown: { en: 'Unknown', fr: 'Inconnu', es: 'Desconocido' },
  labelDate: { en: 'Date', fr: 'Date', es: 'Fecha' },
  common_start_date: { en: 'Start Date', fr: 'Date de début', es: 'Fecha de inicio' },
  common_end_date: { en: 'End Date', fr: 'Date de fin', es: 'Fecha de finalización' },
  common_date_range: { en: 'Date Range', fr: 'Période', es: 'Rango de fechas' },
  common_time: { en: 'Time', fr: 'Heure', es: 'Hora' },
  labelNotes: { en: 'Notes', fr: 'Notes', es: 'Notas' },
  labelRemarks: { en: 'Remarks', fr: 'Remarques', es: 'Observaciones' },
  checklist_description: { en: 'Description', fr: 'Description', es: 'Descripción' },
  veh_type: { en: 'Type', fr: 'Type', es: 'Tipo' },
  user_required_role: { en: 'Role', fr: 'Rôle', es: 'Rol' },
  labelCompany: { en: 'Company', fr: 'Entreprise', es: 'Empresa' },
  app_division: { en: 'Division', fr: 'Division', es: 'División' },
  label_divisions_title: { en: 'Divisions', fr: 'Divisions', es: 'Divisiones' },
  app_group: { en: 'Group', fr: 'Groupe', es: 'Grupo' },
  label_groups_title: { en: 'Groups', fr: 'Groupes', es: 'Grupos' },
  common_filters: { en: 'Filters', fr: 'Filtres', es: 'Filtros' },
  common_sort_by: { en: 'Sort By', fr: 'Trier par', es: 'Ordenar por' },
  timesheet_total_label: { en: 'Total', fr: 'Total', es: 'Total' },
  common_image: { en: 'Image', fr: 'Image', es: 'Imagen' },
  vehicle_make_label: { en: 'Make', fr: 'Marque', es: 'Marca' },
  vehicle_model_label: { en: 'Model', fr: 'Modèle', es: 'Modelo' },
  vehicle_year_label: { en: 'Year', fr: 'Année', es: 'Año' },
  vehicle_attribute_label: { en: 'Attributes', fr: 'Attributs', es: 'Atributos' },
  common_commercial: { en: 'Commercial', fr: 'Commercial', es: 'Comercial' },
  common_submitted: { en: 'Submitted', fr: 'Soumis', es: 'Enviado' },

  // Things (section and page names)
  labelUser: { en: 'User', fr: 'Utilisateur', es: 'Usuario' },
  user_title: { en: 'Users', fr: 'Utilisateurs', es: 'Usuarios' },
  labelVehicle: { en: 'Vehicle', fr: 'Véhicule', es: 'Vehículo' },
  labelVehicles: { en: 'Vehicles', fr: 'Véhicules', es: 'Vehículos' },
  vehicle_equipment_label: { en: 'Equipment', fr: 'Équipement', es: 'Equipo' },
  app_settings_inspections: { en: 'Inspections', fr: 'Inspections', es: 'Inspecciones' },
  hos_title: { en: 'Hours of Service', fr: 'Heures de service', es: 'Horas de servicio' },
  labelHours: { en: 'Hours', fr: 'Heures', es: 'Horas' },
  checklist_checklist_title: { en: 'Checklist', fr: 'Liste de vérification', es: 'Lista de verificación' },
  common_checklists: { en: 'Checklists', fr: 'Listes de vérification', es: 'Listas de verificación' },
  app_map_title: { en: 'Map', fr: 'Carte', es: 'Mapa' },
  common_dashboard: { en: 'Dashboard', fr: 'Tableau de bord', es: 'Panel' },
  common_invoices: { en: 'Invoices', fr: 'Factures', es: 'Facturas' },
  action_signout: { en: 'Sign Out', fr: 'Déconnexion', es: 'Cerrar sesión' },

  // Form rules
  common_rule_required: { en: 'This field is required.', fr: 'Ce champ est obligatoire.', es: 'Este campo es obligatorio.' },
  common_rule_required_short: { en: 'This field is required', fr: 'Ce champ est obligatoire', es: 'Este campo es obligatorio' },
  common_rule_email: { en: 'Must be a valid email address.', fr: 'Doit être une adresse courriel valide.', es: 'Debe ser una dirección de correo electrónico válida.' },
};
